import { Component, HostListener, OnInit } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { DialogService } from "primeng/dynamicdialog";
import { Subject, interval, timer } from "rxjs";
import { filter, last, map, mergeMap } from "rxjs/operators";
import { LocalstorageService, UserService } from "../../../shared";
import { MasterService, MenuService } from "../services";
import { UserFavoritesRequest } from "../services/Info/UserFavoritesRequest";
import { MySettingsDialogComponent } from "./my-settings-dialog/my-settings-dialog.component";

import { NavNotificationService } from "./navnotification.service";
import { AppConfig } from "../../../../config/app.config";
declare var moment: any;
@Component({
	selector: "caass-navnotification",
	templateUrl: "./navnotification.component.html",
	styleUrls: ["./navnotification.component.css"],
})
export class NavnotificationComponent implements OnInit {
	attendanceVerify = false;
	closeResult: string;
	public visible = false;
	showVerify = false;
	savingVerifify = false;
	showtodayList = false;
	pbuttonColor;
	abuttonColor;
	showToday = false;
	showAll = false;
	verifyStudentList: any = [];
	verifystudentList: any = [];
	public visibleAnimate = false;
	allDate = "1/1/1990";
	classDate;
	today = new Date();
	name;
	markPresent = false;
	markAbsent = false;
	OpenVerify = false;
	private allItems: any[];
	originalStudentList: any = [];
	// pager object
	pager: any = {};
	numberOfNotification = 0;

	// paged items
	pagedItems: any[];
	private currentPage: any = 1; // set current page to 1
	public itemsPerPage: any = 2;
	Title: string = "DashBoard";

	SBMInboxCountSubscription: any;
	SBMInboxTimerSubscription: any;
	SBMInboxCount: number = 0;

	ReportInboxCountSubscription: any;
	ReportInboxTimerSubscription: any;
	ReportInboxCount: number = 0;

	RefreshMinutes: number = 5;
	SBMRefreshing: boolean = false;
	ReportRefreshing: boolean = false;

	UserTooltip: string = "";

	currentUser: any;
	username: string;

	FavoriteLoading: boolean = false;
	CanFavorite: boolean = false;
	PageFavorited: boolean = false;

	CheckFavoriteTopBar: any;

	SBMEnabled: boolean = false;

	DoSSOLogout: boolean = false;
	InactiveMinutes: number = 10;
	UserActivity: any;
	UserInactive: Subject<any> = new Subject();

	constructor(
		private router: Router,
		private userService: UserService,
		private notificationService: NavNotificationService,
		private activatedRoute: ActivatedRoute,
		private dialogService: DialogService,
		private masterService: MasterService,
		private menuService: MenuService,
		private config: AppConfig,
		private localService: LocalstorageService
	) {}

	ngOnInit() {
		this.currentUser = this.userService.getCurrentUser();

		this.username = this.currentUser.userName;
		this.classDate = this.allDate;
		this.AttendanceVerifyStudentList();
		this.showVerify = false;

		let r = this.activatedRoute;
		while (r.firstChild) r = r.firstChild;

		this.Title = r.snapshot.data["title"];
		this.CheckFavorited();

		this.router.events
			.pipe(filter((event) => event instanceof NavigationEnd))
			.pipe(map(() => this.activatedRoute))
			.pipe(
				map((route) => {
					while (route.firstChild) route = route.firstChild;
					return route;
				})
			)
			.pipe(filter((route) => route.outlet === "primary"))
			.pipe(mergeMap((route) => route.data))
			.subscribe((event) => {
				if (event["title"]) {
					this.Title = event["title"];

					this.CheckFavorited();
				}
			});

		this.CheckFavoriteTopBar = this.menuService.CheckFavoriteTopBarObservable.subscribe((data) => this.CheckFavorited());

		this.CheckSBMEnabled();

		this.loadReportInboxCount();
		this.ReportInboxCountSubscription = this.menuService.onReportInboxChange().subscribe((val) => {
			if (val == "Refresh") {
				this.loadReportInboxCount();
			}
		});

		this.loadCurrentRoles();

		//
		//	Logout after x Minutes
		//
		this.loadNavbarPreference();
	}

	ngOnDestroy() {
		this.CheckFavoriteTopBar.unsubscribe();

		if (this.SBMEnabled == true) {
			this.SBMInboxCountSubscription.unsubscribe();
			this.SBMInboxTimerSubscription.unsubscribe();
		}

		this.ReportInboxCountSubscription.unsubscribe();
		this.ReportInboxTimerSubscription.unsubscribe();

		this.UserInactive.unsubscribe();
	}

	InitLogoutTimer() {
		this.RestartTimer();
		this.UserInactive.subscribe(() => {
			//
			// Check if any other CAASS tabs were active recently
			//
			var ExpireDT: Date = new Date();
			ExpireDT.setMinutes(ExpireDT.getMinutes() - this.InactiveMinutes);

			var lastActiveDT: Date = new Date(this.localService.getItem("LastActiveDT"));

			// console.log("This tab's timer Expire DT:");
			// console.log(ExpireDT);

			// console.log("Last Active DT (Including other CAASS Tabs):");
			// console.log(lastActiveDT);

			// console.log("User was active more recently than this tab thought?");
			// console.log(lastActiveDT > ExpireDT);

			if (lastActiveDT > ExpireDT) {
				this.RestartTimer();
			} else {
				this.UserInactiveLogout();
			}
		});
	}

	RestartTimer() {
		this.UserActivity = setTimeout(() => this.UserInactive.next(undefined), this.InactiveMinutes * 60 * 1000);
	}

	@HostListener("window:mousemove") refreshUserState() {
		clearTimeout(this.UserActivity);
		this.localService.setItem("LastActiveDT", new Date());
		this.RestartTimer();
	}

	UserInactiveLogout() {
		console.log("User has been inactive for " + this.InactiveMinutes + " minutes");
		this.logout();
	}

	CheckSBMEnabled() {
		var result = this.menuService.SBMEnabledSelect();
		result.subscribe(
			(response: any) => {
				if (response.Success == true) {
					this.SBMEnabled = true;

					this.loadSBMInboxCount();
					this.SBMInboxCountSubscription = this.menuService.onInboxChange().subscribe((val) => {
						if (val == "Refresh") {
							this.loadSBMInboxCount();
						}
					});
				}
			},
			(error) => {}
		);
	}

	CheckFavorited() {
		this.PageFavorited = false;
		this.CanFavorite = false;

		try {
			var currentKey: String = String(
				this.masterService.getCurrentApplicationItemByUrl(this.router.routerState.snapshot.url).ApplicationItemKey
			).toLowerCase();

			var lstMenu: any = this.activatedRoute.snapshot.data.menu;
			var favorites: any = null;

			for (var z = 0; z < lstMenu.length; z++) {
				var next = lstMenu[z];

				if (String(next.ApplicationItemID).toLowerCase() == String("4ff43b7e-baf8-4015-9df3-3f1f19db2314").toLowerCase()) {
					favorites = next;
					break;
				}
			}

			for (var z = 0; z < favorites.Children.length; z++) {
				var next = favorites.Children[z];

				if (String(next.ApplicationItemKey).toLowerCase() == currentKey) {
					this.PageFavorited = true;
					break;
				}
			}

			var currentAppID: String = String(
				this.masterService.getCurrentApplicationItemByUrl(this.router.routerState.snapshot.url).ApplicationItemID
			).toLowerCase();

			if (currentAppID != "00000000-0000-0000-0000-000000000000") {
				this.CanFavorite = true;
			}
		} catch (e) {
			e.toString();
		}
	}

	onFavorite() {
		this.FavoriteLoading = true;

		let parms: UserFavoritesRequest = {
			UserID: this.currentUser.userID,
			ApplicationItemID: String(this.masterService.getCurrentApplicationItemByUrl(this.router.routerState.snapshot.url).ApplicationItemID).toUpperCase(),
		};

		var result = this.notificationService.UserFavoriteInsertByID(parms);
		result.subscribe(
			(response) => {
				this.FavoriteLoading = false;
				this.menuService.MenuRefreshFavorites("refresh");

				if (response) {
					this.PageFavorited = true;
				} else {
				}
			},
			(error) => {
				this.FavoriteLoading = false;
			}
		);
	}

	onUnFavorite() {
		this.FavoriteLoading = true;

		let parms: UserFavoritesRequest = {
			UserID: this.currentUser.userID,
			ApplicationItemID: String(this.masterService.getCurrentApplicationItemByUrl(this.router.routerState.snapshot.url).ApplicationItemID).toUpperCase(),
		};

		var result = this.notificationService.UserFavoriteDeleteByID(parms);
		result.subscribe(
			(response) => {
				this.FavoriteLoading = false;
				this.menuService.MenuRefreshFavorites("refresh");

				if (response) {
					this.PageFavorited = false;
				} else {
				}
			},
			(error) => {
				this.FavoriteLoading = false;
			}
		);
	}

	tabclick($event) {
		$("body").toggleClass("mini-navbar");
		$event.preventDefault();

		if ($("body").hasClass("mini-navbar")) {
			this.menuService.CollapseMenu(true);
		} else {
			this.menuService.CollapseMenu(false);
		}
	}

	onCheckboxChange(event) {
		if (event.target.checked) {
			this.showToday = true;
			this.classDate = this.today;
			this.AttendanceVerifyStudentList();
		} else {
			this.showAll = true;
			this.classDate = this.allDate;
			this.AttendanceVerifyStudentList();
		}
	}
	/*openLg(content) {
    this.modalService.open(content, { size: 'lg' });
  }*/

	verifyAttendance() {
		this.attendanceVerify = true;
	}

	AttendanceVerifyStudentList() {
		this.OpenVerify = false;
		this.verifystudentList = [];
		this.verifyStudentList = [];

		var result = this.notificationService.AttendanceVerifyStudentList(moment(this.classDate).format("MM/DD/YYYY"));

		result.subscribe(
			(response: any) => {
				this.verifystudentList = response;
				this.showAll = false;
				this.showToday = false;
				for (let i of this.verifystudentList) {
					if (i.ClassCountHistory < 2) {
						this.verifyStudentList.push(i);
					}
				}
				if (this.verifystudentList.length == null || this.verifystudentList.length == 0) {
					this.OpenVerify = true;
					return 0;
				}
				this.numberOfNotification = this.verifyStudentList.length;
				var originalStudentList = this.originalStudentList;
				this.allItems = this.verifyStudentList;

				// initialize to page 1
				this.setPage(1);

				if (this.verifyStudentList.length > 1) {
					if (this.verifyStudentList.length > 0) {
						this.verifyStudentList.StudentID = this.verifyStudentList[0].StudentID;
					}
				}
			},
			(error) => {}
		);
	}

	setPage(page: number) {
		// get pager object from service
		this.pager = this.notificationService.getPager(this.allItems.length, page);

		// get current page of items
		this.pagedItems = this.allItems.slice(this.pager.startIndex, this.pager.endIndex + 1);
	}

	setBColor(event: any, studentID, classAttendanceStudentID) {
		this.savingVerifify = true;
		var lstUpdatedList = [];
		this.markPresent = false;
		this.markAbsent = false;
		var originalStudentList = this.originalStudentList;
		var student = this.pagedItems.filter((a) => {
			return a.StudentID == studentID && a.ClassAttendanceStudentID == classAttendanceStudentID;
		});
		var target = event.target || event.srcElement || event.currentTarget;
		var idAttr = target.attributes.id;
		var value = idAttr.nodeValue;

		student[0].ClassAttendanceStatusID = 0;
		if (value == "pButton") {
			student[0].ClassAttendanceStatusID = 1;
			student[0].ClassAttendanceStatusCD = "P";
			student[0].ClassAttendanceStatusDesc = "Present for Class";

			this.abuttonColor = "";
			this.pbuttonColor = "green";

			{
				lstUpdatedList.push(student[0]);
			}

			var result = this.notificationService.ClassAttendanceModify(lstUpdatedList, this.classDate);

			result.subscribe(
				(response: any) => {
					this.savingVerifify = false;
					this.markPresent = true;
					this.markAbsent = false;
					this.FadeOutLink();
				},
				(error) => {
					alert("Error occured while saving, Please save again");
				}
			);
		} else if (value == "aButton") {
			student[0].ClassAttendanceStatusID = 2;
			student[0].ClassAttendanceStatusCD = "A";
			student[0].ClassAttendanceStatusDesc = "Absent from Class";
			this.pbuttonColor = "";
			this.abuttonColor = "red";

			{
				lstUpdatedList.push(student[0]);
			}

			var result = this.notificationService.ClassAttendanceModify(lstUpdatedList, this.classDate);

			result.subscribe(
				(response: any) => {
					this.savingVerifify = false;
					this.markPresent = false;
					this.markAbsent = true;
					this.FadeOutLink();
				},
				(error) => {
					alert("Error occured while saving, Please save again");
				}
			);
		}
		student[0].pbuttonColor = this.pbuttonColor;
		student[0].abuttonColor = this.abuttonColor;
	}
	cancelVerification() {
		this.classDate = this.allDate;
		this.numberOfNotification = 0;
		this.attendanceVerify = false;
		this.AttendanceVerifyStudentList();
	}
	cancelVerificationWindow() {
		this.attendanceVerify = false;
		this.classDate = this.allDate;
		this.numberOfNotification = 0;
		this.AttendanceVerifyStudentList();
	}
	submitVerification() {
		this.attendanceVerify = false;
		this.classDate = this.allDate;
		this.numberOfNotification = 0;
		this.AttendanceVerifyStudentList();
	}
	showVerifyAttendance() {
		this.showVerify = true;
	}
	noshowVerifyAttendance() {
		this.showVerify = false;
	}
	todayList() {
		this.showtodayList = true;
	}
	notodayList() {
		this.showtodayList = false;
	}
	FadeOutLink() {
		setTimeout(() => {
			this.markAbsent = false;
			this.markPresent = false;
		}, 4000);
	}

	logout() {
		var SSOLogoutLink = "";
		var user = this.userService.getCurrentUser();
		if (user != undefined && user.SSOLogoutLink != undefined) {
			SSOLogoutLink = String(user.SSOLogoutLink);
		}

		this.userService.setCurrentUser(null);

		//
		//	Using SSO Single-Logout
		//		Ex. Logout of CAASS, then logout of Okta?
		//
		if (this.DoSSOLogout == true && SSOLogoutLink != undefined && SSOLogoutLink != "") {
			var a = document.createElement("a"); //Create <a>
			a.href = SSOLogoutLink;
			a.click();
		} else {
			this.router.navigate(["/login"]);
		}
	}

	private loadSBMInboxCount() {
		if (this.SBMEnabled == true) {
			var result = this.menuService.InboxCountSelect();
			result.subscribe(
				(response) => {
					this.SBMInboxCount = response[0];
					this.RefreshData();
				},
				(error) => {
					this.RefreshData();
				}
			);
		}
	}

	private loadReportInboxCount() {
		var result = this.menuService.ReportInboxCountSelect();
		result.subscribe(
			(response: any) => {
				this.ReportInboxCount = Number(response);
				this.RefreshData();
			},
			(error) => {
				this.RefreshData();
			}
		);
	}

	private loadNavbarPreference() {
		var result = this.notificationService.NavbarPreferenceSelect();
		result.subscribe(
			(response: any) => {
				this.InactiveMinutes = response.InactiveLogoutMinutes;
				this.DoSSOLogout = response.SSOLogoutEnabled;

				if (this.InactiveMinutes > 0) {
					this.InitLogoutTimer();
				}
			},
			(error) => {
				this.RefreshData();
			}
		);
	}

	private loadCurrentRoles() {
		var result = this.menuService.CurrentRoleTooltipSelect();
		result.subscribe(
			(response: any) => {
				this.UserTooltip = response.str;
			},
			(error) => {}
		);
	}

	async RefreshData() {
		if (this.SBMEnabled == true) {
			if (!this.SBMRefreshing) {
				this.SBMRefreshing = true;
				var ms = this.RefreshMinutes * 1000 * 60; //Default 5 minutes

				this.SBMInboxTimerSubscription = timer(ms, ms).subscribe((x) => {
					this.loadSBMInboxCount();
				});
			}
		}

		if (!this.ReportRefreshing) {
			this.ReportRefreshing = true;
			var ms = this.RefreshMinutes * 1000 * 60; //Default 5 minutes

			this.ReportInboxTimerSubscription = timer(ms, ms).subscribe((x) => {
				this.loadReportInboxCount();
			});
		}
	}

	////////////////////////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////////////////////////

	onSettings() {
		//
		// Open dialog
		//
		var ref = this.dialogService.open(MySettingsDialogComponent, {
			header: "My Settings",
			width: "fit-content",
			data: {},
		});
		ref.onClose.subscribe((response) => {});
	}

	onGoToSBMInbox() {
		var RedirectUrl = "";
		var BaseUrl = this.config.getConfig("baseURL");

		if (BaseUrl.indexOf("localhost") > 0) {
			BaseUrl = "http://localhost:4201/";
		} else {
			BaseUrl += "sbm/";
		}

		RedirectUrl = BaseUrl + "#/sbm/incidents/inbox";
		window.location.href = RedirectUrl;
	}

	onGoToReportInbox() {
		this.router.navigate(["/inboxreport/inbox"]);
		// window.location.href = "#/inboxreport/inbox";
	}

	////////////////////////////////////////////////////////////////
}
